import type { TrainingOption } from '@hcc/types';

/**
 * Single-choice answer: full-width tappable rows (44px+ targets for
 * tablets), one selectable at a time. Controlled; knows nothing about
 * correctness — grading is server-side.
 */
export function RadioAnswer({
  options,
  value,
  onChange,
  disabled,
  ariaLabelledBy,
}: {
  options: TrainingOption[];
  value: string | undefined;
  onChange: (next: string) => void;
  disabled?: boolean;
  ariaLabelledBy?: string;
}) {
  return (
    <div role="radiogroup" aria-labelledby={ariaLabelledBy} className="flex flex-col gap-2">
      {options.map((o) => {
        const selected = value === o.id;
        return (
          <button
            key={o.id}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => onChange(o.id)}
            className={`flex min-h-[44px] w-full items-center gap-3 rounded-token-sm border px-4 py-3 text-left text-sm transition-colors disabled:opacity-60 ${
              selected
                ? 'border-accent bg-accent/10 text-fg'
                : 'border-line/10 bg-surface text-fg hover:bg-surface-2'
            }`}
          >
            <span
              aria-hidden
              className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${
                selected ? 'border-accent' : 'border-line-strong/40'
              }`}
            >
              {selected ? <span className="h-2.5 w-2.5 rounded-full bg-accent" /> : null}
            </span>
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
